import React, {useState, useEffect } from "react";
import Ecg from '../../Ecg';
/*
* Authentication
*/
import Alt from 'alt';
import axios from 'axios';
import AuthActions from '../../../actions/AuthActions';
import AuthStore from '../../../stores/AuthStore';

import Constants from '../../../Components/Constants'

import {
  Alert,
  Badge,
  Container,
  Row,
  Col,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Card,
  CardHeader,
  CardBlock,
  CardFooter,
  CardTitle,
  Button,
  Label,
  Input,
  Table,
  Modal, ModalHeader, ModalBody, ModalFooter,
  Media, InputGroup, InputGroupAddon
} from "reactstrap";

import classnames from "classnames";

import Select from 'react-select';
import 'react-select/dist/react-select.css';

export default function ExamViewer(props, history) {
	
	const [isLoading, setIsLoading] = useState(true);
	const [exam, setExam] = useState(props.exam);
	const [anteriorExams, setAnteriorExams] = useState([]);
	const [anteriorExamSelect, setAnteriorExamSelect] = useState(null);
	const [anteriorExam, setAnteriorExam] = useState(null);
	const [derivations, setDerivations] = useState([]);
	const [isModalComparationOpen, setModalComparationOpen] = useState(false);
	const [anteriorExamDerivation, setAnteriorExamDerivation] = useState(null);
	const [equipamentStartFromInit, setSquipamentStartFromInit] = useState({
              "EQUIPMENT_AEROTEL": 1,
              "EQUIPMENT_TEB": 0,
              "EQUIPMENT_CARDIOWEB_SERVER": 1,
              "EQUIPMENT_CARDIOWEB_CLIENT": 1,
              "EQUIPMENT_PHYSIO_GLOVE": 0,
              "EQUIPMENT_MICROMED_600": 1,
              "EQUIPMENT_MICROMED_300": 1,
              "EQUIPMENT_EPEOPLE": 1,
              "EQUIPMENT_VENTRIX": 1,
			  "EQUIPMENT_BIONET_CARDIOXP": 0
            });
	
	const [derivationNames, setDerivationNames] = useState(["I", "II", "III", "aVR", "aVL", "aVF", "V1", "V2", "V3", "V4", "V5", "V6"]);

	useEffect(() => {
		
		let tempExam = exam;
		exam.derivations = props.derivations;
		
		getExams();
		
	}, []);
	
	function toogleModal(){
		setModalComparationOpen(!isModalComparationOpen);
	}
	
	function getAge(dateString){
      let today = new Date();
      let birthDate = new Date(dateString);
      let age = today.getFullYear() - birthDate.getFullYear();
      let m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate()))
      {
          age--;
      }
      return age;
    }
	
	function getExams() {
		//Busca exames anteriores
		axios({
			method: 'get',
			url: Constants.apiUrl+'/api/v1/exam/patient/'+props.exam.patient.id
		})
		.then(res => {
		  let anteriorExamsList = [];

		  res.data.forEach(anteriorExam => {
			let receivedDate = new Date(anteriorExam.dtReceived);
			let formatedDate =  formatDate(receivedDate);

			if(anteriorExam.id != exam.id){
			  anteriorExamsList.push({
				value: anteriorExam.id,
				label: anteriorExam.publicId + " "+ formatedDate
			  });
			}

			setAnteriorExams(anteriorExamsList);
			setIsLoading(false);
		  });
		});
	}
	
	function pad(a,b){return(1e15+a+"").slice(-b)}
	
	function formatDate(date){
      return pad(date.getDate(), 2) +"/"+pad((date.getMonth()+1), 2) +"/"+date.getFullYear() +
      " "+ pad(date.getHours(), 2)+":"+pad(date.getMinutes()+1, 2)+":"+date.getSeconds();
    }
	
	function compareExams(){
		if(anteriorExamSelect != null){

			axios({
				method: 'get',
				url: Constants.apiUrl+'/api/v1/exam/'+anteriorExamSelect
			})
			.then(response => {
				//Separa as derivações do ECGDATA
				let amostras = response.data.ecgData.split(',');
				let nAmostras = amostras.length / 12;
				let derivations = new Array(12);

				for (let x = 0; x < 12; x++) {
					derivations[x] = new Array(nAmostras);
				}

				for (let i = 0; i < amostras.length; i++) {
					let d = parseInt(i % 12);
					let pos = parseInt(i / 12);

					derivations[d][pos] = amostras[i];
				}

				response.data.derivations = derivations
				setAnteriorExam(response.data);
                setAnteriorExamDerivation(0);
			});
		}
	}
	
	return (
		<div>
		{isLoading ? (
			<div className="text-center">
              <i className="fa fa-circle-o-notch fa-spin fa-fw"></i>
            </div>
		) : (
		<div>
            <div onClick={() => {setModalComparationOpen(true)}} className={"link-style "+ (anteriorExams.length > 0 ? '' : "hidden")}>
                Comparar exames
            </div>
			<Modal isOpen={isModalComparationOpen} toggle={toogleModal} className="info" size="lg" autoFocus={false}>
              <ModalHeader toggle={toogleModal}>Comparação de Exames</ModalHeader>
                <ModalBody>
                  <Select
                        className="m-1 w-100"
                        id="state-select"
                        autoFocus
                        options={anteriorExams}
                        simpleValue
                        clearable={true}
                        name="selected-state"
                        disabled={anteriorExams.length <= 0}
                        value={anteriorExamSelect}
                        onChange={(val) => {setAnteriorExamSelect(val)}}
                        openOnClick={false}
                        searchable={true}
                    />
                    <Button color="primary m-1 w-100" onClick={compareExams} 
                        disabled={(anteriorExams.length <= 0 || anteriorExamSelect == null || anteriorExamSelect == "")}>
                        <i className="fa fa-exchange"></i>{'\u00A0'} Comparar Exames
                        </Button>
                    <hr />
                    
                  <b>Paciente:</b>
                  <Row>
                    <Col md="6">
                      Nome: {anteriorExam == null ? "" : anteriorExam.patient.firstname +" "+ anteriorExam.patient.lastname}
                    </Col>
                    <Col md="2">
                      Idade: {anteriorExam == null ? "" : getAge(anteriorExam.patient.dtBirthDate)}
                    </Col>
                    <Col md="2">
                      Sexo: {anteriorExam == null ? "" : (anteriorExam.patient.gender == "FEMALE" ? "Feminino": "Masculino")}
                    </Col>
                  </Row>

                  <hr />

                  <Row>
                    <Col md="3">
                      <b>Exame Anterior</b>
                    </Col>
                    <Col md="4">
                      Registro: {anteriorExam == null ? "" : anteriorExam.publicId}
                    </Col>
                    <Col md="5">
                      Recepção: {anteriorExam == null ? "" : formatDate(new Date(anteriorExam.dtReceived))}
                    </Col>
                  </Row>
                  <Row className="row-no-padding row-bordered ecg-panel-row ">
                      <Col xs="12" sm="12">
                      {
                        anteriorExam == null ? null :
                        (
                          <Ecg ecgData={anteriorExam.derivations[anteriorExamDerivation]} id="comparable-derivation" drawGrid={true} drawMarks={false}
                          totalTime="10" displayTime="10" ECGLineColor="#005500" traceName={derivationNames[anteriorExamDerivation]}
                          ecgSampleRate={anteriorExam == null ? 0 : anteriorExam.ecgSampleRate}
                          ecgResolution={anteriorExam == null ? 0 : anteriorExam.ecgResolution} />
                        )
                      }
                      </Col>
                  </Row>
                  <br />
                  <Row>
                    <Col xs="4" sm="6">
                      <Select
                        options={
                          [{value: 0, label:"I"}, {value: 1, label:"II"}, {value: 2, label:"III"}, {value: 3, label:"aVR"}, {value: 4, label:"aVL"}, {value: 5, label:"aVF"},
                            {value: 6, label:"V1"},{value: 7, label:"V2"}, {value: 8, label:"V3"}, {value: 9, label:"V4"}, {value: 10, label:"V5"}, {value: 10, label:"V6"} ]
                        }
                        simpleValue
                        value={anteriorExamDerivation}
                        onChange={(val) => {setAnteriorExamDerivation(val)}}
                        openOnClick={false}
                      />
                      </Col>
                  </Row>

                  <hr />

                  <Row>
                    <Col md="3">
                      <b>Exame Atual</b>
                    </Col>
                    <Col md="4">
                      Registro: {exam == null ? "" :exam.publicId}
                    </Col>
                    <Col md="5">
                      Recepção: {exam == null ? "" : formatDate(new Date(exam.dtReceived))}
                    </Col>
                  </Row>

                  <Row className="row-no-padding row-bordered ecg-panel-row ">
                      <Col xs="12" sm="12">
                      {
                        exam.derivations == null ? null :
                        (
                          <Ecg ecgData={exam.derivations[anteriorExamDerivation]} id="actual-exam-derivation" drawGrid={true} drawMarks={false}
                          totalTime="10" displayTime="10" ECGLineColor="#005500" traceName={derivationNames[anteriorExamDerivation]}
                          ecgSampleRate={exam == null ? 0 : exam.ecgSampleRate}
                          ecgResolution={exam == null ? 0 : exam.ecgResolution} />
                        )
                      }
                      </Col>
                  </Row>

                </ModalBody>

              <ModalFooter>
                <Button color="danger" onClick={toogleModal}>Fechar</Button>
              </ModalFooter>
            </Modal>
		</div>
		)}
		</div>
	);
}


// WEBPACK FOOTER //
// ./src/views/Components/ExamComparator/ExamComparator.js